<template>
  <div>
    <yv-index
      :path="path"
      :inlineSearchAction="true"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :tableActionsComponent="TableActions"
      :sortable="sortable"
      :formatTableData="formatTableData"
      mainField="full_name"
      ref="templateTable"
    >
      <template #search-actions="{ actions }">
        <div class="flex justify-between">
          <md-button
            native-type="submit"
            @click="actions.search"
            class="md-info md-round"
          >
            {{ $t("common.search") }}
          </md-button>
          <md-button
            native-type="submit"
            @click="sendSms"
            class="md-success md-round ml-auto"
          >
            {{ $t("communication.send_sms") }}
          </md-button>
        </div>
      </template>
    </yv-index>
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_names } from "@/constants/Services";
import TableActions from "./tableAction.vue";
import { formatDateClient } from "@/helpers/datetime-helper";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "ListPage",
  components: {
    YvIndex
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role",
      userTz: "timezone",
      userInfo: "info"
    })
  },
  data() {
    return {
      path: `${service_names.school}/sms`,
      TableActions,
      formSearch: [
        {
          label: "communication.tilte_sms",
          name: "title",
          value: "",
          type: "input"
        },
        {
          label: "communication.sent_time",
          name: "sent_time",
          value: [],
          type: "date-range",
          width: 30
        }
      ],
      columns: {
        title: "communication.tilte_sms",
        count_user: "communication.number_of_user",
        sent: "communication.sent",
        sent_time: "communication.sent_time"
      },
      sortable: ["title"]
    };
  },
  methods: {
    convertTimezone(time, zone) {
      if (!time) return "";
      return zone
        ? this.formatTime(
            time,
            zone === "UTC" ? this.userInfo.school.timezone : zone
          )
        : this.formatTime(time, this.userInfo.school.timezone);
    },
    formatTime(time, timeZone) {
      const moment = require("moment-timezone");
      return moment(time + " ZZ", "YYYY-MM-DD hh:mm:ss ZZ")
        .tz(timeZone)
        .format(`YYYY-MM-DD HH:mm:ss`);
    },
    fetchDataTable() {
      return this.$refs.templateTable.getTableData();
    },
    sendSms() {
      this.$emit("send-sms");
    },
    detailSms(item) {
      this.$emit("detail-sms", item);
    },
    formatTableData(tableData) {
      return tableData.map(smsData => {
        smsData.sent_time =
          smsData.sent_time &&
          this.convertTimezone(smsData.sent_time, this.userTz);
        smsData.sent_time = `<p>${moment(smsData.sent_time).format(
          `${formatDateClient} HH:mm:ss`
        )}</p>`;
        return smsData;
      });
    }
  },
  provide() {
    return {
      detailSms: this.detailSms
    };
  }
};
</script>

<style scoped lang="scss">
.md-button {
  border-radius: 100px !important;
  float: right;
}
::v-deep .md-table-row td:nth-child(2) {
  width: 50%;
}
</style>
